module.exports = __webpack_public_path__ + "90e335d0.svg";